import { IMPRESSION_ACTIONS } from "@cart-client/analytics/constants/Action";
import { SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionCartWidgetRanking = ({
    impressionEvent,
    widgetSequence,
    cartId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    widgetSequence: string;
    cartId: number | string;
}): void => {
    impressionEvent({
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_WIDGET_RANKING,
        category: SCREEN_NAME.CHECKOUT,
        context: widgetSequence,
        extraParams: JSON.stringify({ cartId }),
    });
};
